module.exports = __webpack_public_path__ + "img/foton_thumbnail.dc831137.png";